import {TrackingCode} from "@/services/DTOs/TrackingCode";

export interface ICandidateTrackingUtm {
  utm_medium?: string;
  utm_source?: string;
  utm_campaign?: string;
  opportunityId?: string;
}

export class CandidateTrackingUtm {
  public utmSource?: string;
  public utmMedium?: string;
  public utmCampaign?: string;
  public opportunityId?: string;

  constructor(data: ICandidateTrackingUtm) {
    this.utmSource = data.utm_source;
    this.utmMedium = data.utm_medium;
    this.utmCampaign = data.utm_campaign;
    this.opportunityId = data.opportunityId;
  }

  public areAllUtmsPresent(): boolean {
    return !!(this.utmCampaign && this.utmMedium && this.utmSource);
  }

  public toTrackingCode(path: string): TrackingCode {
    return new TrackingCode({
      utmCampaign: this.utmCampaign || "",
      utmSource: this.utmSource || "",
      utmMedium: this.utmMedium || "",
      path
    });
  }
}
